import React, { useState, useEffect, useRef } from 'react';
import OwlCarousel from 'react-owl-carousel3';
import { Link } from "react-router-dom";
import ImgTrendingPrd from '../../assets/img/trending-prd.png';
import ImgmComingSoon from '../../assets/img/commingsoon.png';
import apiPath from "../../constants/apiPath";
import Http from "../../services/Http";
import toast from 'react-hot-toast';
import Currency from './Currency';
import LocalizedStrings from 'react-localization';
import localizations from "../../localization";
let strings = new LocalizedStrings(localizations);

/** Custom countdown hook */
const useCountdown = (targetDate) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const countDownDate = useRef(targetDate ? new Date(targetDate).getTime() : null);

  useEffect(() => {
    if (!countDownDate.current) return;
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = countDownDate.current - now;

      if (distance < 0) {
        clearInterval(timerId);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setTimeLeft({ days, hours, minutes, seconds });
      }
    };
    const timerId = setInterval(updateCountdown, 1000);
    updateCountdown();
    return () => clearInterval(timerId);
  }, [targetDate]);

  return timeLeft;
};

/**
 * Calculate delivery date range (today + days)
 */
const getDeliveryRange = (days) => {
  try {
    const start = new Date();
    const end = new Date();

    start.setDate(start.getDate() + days);
    end.setDate(end.getDate() + days + 1);

    const options = { day: 'numeric' };
    const options2 = { day: 'numeric', month: 'long' };

    return `${start.toLocaleDateString('en-GB', options)} - ${end.toLocaleDateString('en-GB', options2)}`;
  } catch (e) {
    return '';
  }
};

/** Subcomponent: Product Item */
const ProductItem = ({ item, index, strings, handleFavourite, showAddtoCart }) => {
  const countdownTarget = item.sale_time > 0 ? new Date(Date.now() + item.sale_time * 60000) : null;
  const { days, hours, minutes, seconds } = useCountdown(countdownTarget);
  const shouldDisplayCountdown = countdownTarget !== null;

  return (
    <div className="item" key={index}>
      <div className="arrival-prd">
        {/* badges */}
        <div className="badge-stack">
          {item.trending_product == 1 && (
            <div className="badge badge-trending">
              🔥 TRENDING
            </div>
          )}
          {(item.out_of_stock == 1 || item.left <= 0) && (
            <div className="badge badge-out">
              OUT OF STOCK
            </div>
          )}
          {item.is_new == 1 && (
            <div className="badge badge-new">
              + NEW
            </div>
          )}

          {item.is_sale == 1 && item.out_of_stock <= 0 && (
            <div className="badge badge-sale">
              {Math.round(((item.original_price - item.discount_price) * 100) / item.original_price)}% SALE
            </div>
          )}
          {item.is_coming_soon == 1 && (
            <div className="badge badge-coming">
              ⏳ COMING SOON
            </div>
          )}
        </div>

        {/* product image */}
        <div className="arrival-prd-img">
          <Link to={`/product-detail/${item.slug}`} target="_blank">
            {item.product_images && item.product_images.length >= 2 ? (
              <div className="img-container">
                <img src={item.product_images[0].image} alt={item.name} className="default-img" />
                <img src={item.product_images[1].image} alt={item.name} className="hover-img" />
              </div>
            ) : (
              <div className="img-container">
                <img src={item.image} alt={item.name} />
              </div>
            )}
          </Link>

          {/* Top right favourite */}
          <div className="fav-absolute">
          <button
              disabled={item.loadingFav}
              className={`fav-btn ${item.is_wishlist == 1 ? 'active' : ''}`}
              onClick={(e) =>
                handleFavourite(e, item.id, item.is_wishlist == 1 ? 'remove' : 'add', index)
              }
            >
              <svg viewBox="0 0 24 24" className="heart-icon">
                <path d="M12 21s-6.7-4.35-9.33-7.07C-0.24 11.02.13 6.8 3.4 4.6 5.5 3.17 8.24 3.88 10 5.6l2 2 2-2c1.76-1.72 4.5-2.43 6.6-1 3.27 2.2 3.64 6.42.73 9.33C18.7 16.65 12 21 12 21z"/>
              </svg>
            </button>
          </div>
        </div>

        {/* details */}
        <div className="arrival-cont">

          <div className="sold_rate">
            {item.rating > 0 && (
              <div className="rating-new">
                <span className="star">★</span>
                <span className="rating">{item.rating}</span>
                <span className="count">({item.total_rating_count})</span>
              </div>
            )}
            <div className="sold_dtl">
              <p>{item.sold > 0 ? `${item.sold} ${strings.sold} & ${item.left} ${strings.left}` : `${item.left} ${strings.left}`}</p>
            </div>
          </div>

          {shouldDisplayCountdown ? (
            <div className="badge-top ribbon-sale">
              Special sale: {days}d {hours.toString().padStart(2, '0')}:
              {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            </div>
          ) : item.is_megadeal == 1 ? (
            <div className="badge-top ribbon-mega">
              Mega Deal 📣
            </div>
          ) : null}

          <div className="arrival-title">
            <h3><Link to={`/product-detail/${item.slug}`} style={{textDecoration: 'none'}} target="_blank">{item.name}</Link></h3>
            {item.brands?.name && (
              <Link to={item.brands ? `/brand/${item.brands.slug}` : '#'} style={{textDecoration: 'none'}}>
                <p className="prd-brand-name">{item.brands.name}</p>
              </Link>
            )}
          </div>

          <div className="arrival-price">
            <p><Currency data={item.discount_price > 0 ? item.discount_price : item.original_price} /></p>
            {item.discount_price > 0 && (
              <p className="discount-price">
                <span><Currency data={item.original_price} /></span>
              </p>
            )}
          </div>

          {/* Tester notice */}
          {item.is_tester && (
            <div className="tester-notice">
              {strings.is_tester}
            </div>
          )}

          {/* Special Slider */}
          {item.special_slider_data && (() => {
            try {
              const sliderData = typeof item.special_slider_data === 'string'
                ? JSON.parse(item.special_slider_data)
                : item.special_slider_data;

              if (!Array.isArray(sliderData) || sliderData.length === 0) return null;
              const duplicated = [...sliderData, ...sliderData];

              return (
                <div className="special-slider-vertical">
                  <div className="slider-vertical-track">
                    {duplicated.map((slide, i) => (
                      <div className="slide-item" key={i}>
                        {slide.image && <img src={slide.image} alt="" />}
                        {slide.text && <span>{slide.text}</span>}
                      </div>
                    ))}
                  </div>
                </div>
              );
            } catch (e) {
              return null;
            }
          })()}
        </div>
        {/* Express Delivery */}
        {item.express_delivery_days > 0 && (
          <div className="express-delivery">
            <span className="express-badge">express</span>
            <span>
              Get it by {getDeliveryRange(item.express_delivery_days)}
            </span>
          </div>
        )}


        {/* actions */}
        <div className="prd-add-option">
          <div className="cart_wrap">
            <Link
              onClick={(e) => {
                if (item.is_coming_soon == 1) e.preventDefault();
                else if ((item.out_of_stock == 0) || (item.left > 0)) showAddtoCart(e, item, item.attributes);
                else window.location.href = `/product-detail/${item.slug}`;
              }}
              className={
                item.is_coming_soon == 1 ? "btn_primary notify_me_new coming_soon" :
                  (item.out_of_stock == 1 || item.left <= 0) ? "btn_primary notify_me_new" : "btn_primary"
              }
              target="_blank"
            >
              {(item.out_of_stock == 1 || item.left <= 0 || item.is_coming_soon == 1)
                ? strings.notifyMe : strings.add_to_bag}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

/** Main Product component */
const Product = (Props) => {

  const [currentLang] = useState(localStorage.getItem("current_lang") || "en");
  strings.setLanguage(currentLang);

  const [products, setProducts] = useState(Props.data || []);

  const [loadingFav, setLoadingFav] = useState({});

  useEffect(() => {
    setProducts(Props.data || []);
  }, [Props.data]);

  const handleFavourite = async (e, id, type, index) => {
    try {
      if (loadingFav[id]) return;
  
      // 🔒 lock
      setLoadingFav(prev => ({ ...prev, [id]: true }));
  
      // optimistic update
      setProducts(prev => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          is_wishlist: type === 'add' ? 1 : 0
        };
        return updated;
      });
  
      const path = apiPath.AddRemoveWishlist;
      const data = new FormData();
      data.append('product_id', id);
      data.append('type', type);
  
      const result = await Http(path, { method: 'POST', data });
  
      if (!(result.status === 200 && result.data.status)) {
        throw new Error(result.data.message || 'Error');
      }
  
      toast.success(result.data.message);
  
    } catch (err) {
      // rollback
      setProducts(prev => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          is_wishlist: type === 'add' ? 0 : 1
        };
        return updated;
      });
  
      toast.error("Error updating wishlist");
  
    } finally {
      setLoadingFav(prev => ({ ...prev, [id]: false }));
    }
  };

  return (
    Props.data ? (
      <OwlCarousel className="owl-carousel owl-theme" {...Props.options}>
        {products.map((item, index) => (
          item.banner_type === 'video' ? (
            <video key={index} width="100%" height={487} controls>
              <source src={item.file} type="video/mp4" />
            </video>
          ) : (
            <ProductItem
              key={index}
              item={item}
              index={index}
              strings={strings}
              handleFavourite={handleFavourite}
              showAddtoCart={Props.showAddtoCart}
            />
          )
        ))}
      </OwlCarousel>
    ) : null
  );
};

export default Product;
